/*
 * @Description:
 * @Date: 2021-02-03 09:22:33
 */
const state = {
  info: {},
  isVisitYsh: false // 是否展示去往医生汇标识
};
const mutations = {
  SET_INFO(state, data) {
    state.info = data;
  },
  SET_YSH(state, status) {
    state.isVisitYsh = status;
  }
};
const actions = {};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
